/** Far-right margin width reserved for the Rovo button, where the Remix button must not show. */
export const RIGHT_MARGIN_ROVO_GAP_PX = 80;
